
import react from 'react'
import { Img } from '../../../components/img'
import { Button } from './button'

import '../css/first-block.css'

export const FirstBlock=()=>{
    return(
        <div className="div1">
            <div className='div1_top'>
                <p className='div1Chance'>більше кодів — більше шансів</p>
                <p className='div1Header'>Вигравай подарунки для пікніку</p>
                <p className='div1Date my-4'>з 23.05.2023 по 03.07.2023</p>
            </div> 
            <div className='div1_middle  mt-4 pt-1'>
                <Button/>
            <div className='div1_verticalLine'></div>
            <div className='d-flex align-items-center'>
            <div className='mx-1' style={{padding:'20px',background:"#fff",borderRadius:'15px'}}>
                <Img height='27px' width='27px' imgPath='ELEMENTS.png'/>
            </div>
            <div className='ms-1 me-4' style={{padding:'20px',background:"#fff",borderRadius:'15px'}}>
                <Img height='25px' width='25px' imgPath='Vector.png'/>
            </div>
                <p className='div1_middle_btn_dec m-1' style={{maxWidth:'160px'}}>або зареєструйте код через чат-бот у Viber чи Telegram</p>
            </div>
            </div>
        </div>
    )
}